// Animals card game data with rankings
export const ANIMALS_CARDS = [
  {
    "id": 1,
    "name": "Dog",
    "rank": 1,
    "image": "/images/animals/animals_1.jpg"
  },
  {
    "id": 2,
    "name": "Cat",
    "rank": 2,
    "image": "/images/animals/animals_2.jpg"
  },
  {
    "id": 3,
    "name": "Horse",
    "rank": 3,
    "image": "/images/animals/animals_3.jpg"
  },
  {
    "id": 4,
    "name": "Chicken",
    "rank": 4,
    "image": "/images/animals/animals_4.jpg"
  },
  {
    "id": 5,
    "name": "Fish",
    "rank": 5,
    "image": "/images/animals/animals_5.jpg"
  },
  {
    "id": 6,
    "name": "Bear",
    "rank": 6,
    "image": "/images/animals/animals_6.jpg"
  },
  {
    "id": 7,
    "name": "Bird",
    "rank": 7,
    "image": "/images/animals/animals_7.jpg"
  },
  {
    "id": 8,
    "name": "Shark",
    "rank": 8,
    "image": "/images/animals/animals_8.jpg"
  },
  {
    "id": 9,
    "name": "Snake",
    "rank": 9,
    "image": "/images/animals/animals_9.jpg"
  },
  {
    "id": 10,
    "name": "Pig",
    "rank": 10,
    "image": "/images/animals/animals_10.jpg"
  },
  {
    "id": 11,
    "name": "Lion",
    "rank": 11,
    "image": "/images/animals/animals_11.jpg"
  },
  {
    "id": 12,
    "name": "Turkey",
    "rank": 12,
    "image": "/images/animals/animals_12.jpg"
  },
  {
    "id": 13,
    "name": "Wolf",
    "rank": 13,
    "image": "/images/animals/animals_13.jpg"
  },
  {
    "id": 14,
    "name": "Spider",
    "rank": 14,
    "image": "/images/animals/animals_14.jpg"
  },
  {
    "id": 15,
    "name": "Rabbit",
    "rank": 15,
    "image": "/images/animals/animals_15.jpg"
  },
  {
    "id": 16,
    "name": "Duck",
    "rank": 16,
    "image": "/images/animals/animals_16.jpg"
  },
  {
    "id": 17,
    "name": "Deer",
    "rank": 17,
    "image": "/images/animals/animals_17.jpg"
  },
  {
    "id": 18,
    "name": "Cow",
    "rank": 18,
    "image": "/images/animals/animals_18.jpg"
  },
  {
    "id": 19,
    "name": "Monkey",
    "rank": 19,
    "image": "/images/animals/animals_19.jpg"
  },
  {
    "id": 20,
    "name": "Lobster",
    "rank": 20,
    "image": "/images/animals/animals_20.jpg"
  },
  {
    "id": 21,
    "name": "Ape",
    "rank": 21,
    "image": "/images/animals/animals_21.jpg"
  },
  {
    "id": 22,
    "name": "Pony",
    "rank": 22,
    "image": "/images/animals/animals_22.jpg"
  },
  {
    "id": 23,
    "name": "Dolphin",
    "rank": 23,
    "image": "/images/animals/animals_23.jpg"
  },
  {
    "id": 24,
    "name": "Bison",
    "rank": 24,
    "image": "/images/animals/animals_24.jpg"
  },
  {
    "id": 25,
    "name": "Orca",
    "rank": 25,
    "image": "/images/animals/animals_25.jpg"
  },
  {
    "id": 26,
    "name": "Giraffe",
    "rank": 26,
    "image": "/images/animals/animals_26.jpg"
  },
  {
    "id": 27,
    "name": "Tiger",
    "rank": 27,
    "image": "/images/animals/animals_27.jpg"
  },
  {
    "id": 28,
    "name": "Coyote",
    "rank": 28,
    "image": "/images/animals/animals_28.jpg"
  },
  {
    "id": 29,
    "name": "Koala",
    "rank": 29,
    "image": "/images/animals/animals_29.jpg"
  },
  {
    "id": 30,
    "name": "Squirrel",
    "rank": 30,
    "image": "/images/animals/animals_30.jpg"
  }
];
